import { HttpEventType, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CharonService } from '@quickweb/connect-angular';
import { Observable } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CaronteService {
  constructor(private charonService: CharonService) {
    this.charonService.config({
      entryPoint: environment.charonEntrypoint,
      httpOptions: {
        headers: new HttpHeaders({ 'x-itau-apikey': environment.apiKey })
      }
    });
  }

  initialize(charonEntryPoint: string) {
    this.charonService.initialize({
      entryPoint: charonEntryPoint
    });
  }

  get(token: string, relation: string, correlationId: string): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${token}`,
        'x-itau-correlationID': correlationId,
        'x-itau-apikey': environment.apiKey
      })
    };

    this.charonService.config({
      entryPoint: environment.charonEntrypoint,
      httpOptions: {
        headers: httpOptions.headers
      }
    });

    return this.charonService.initialize(httpOptions).pipe(
      filter((x: any) => x?.type === HttpEventType.Response),
      switchMap(() => {
        return this.charonService.get(relation, {
          headers: httpOptions.headers,
          observe: 'response'
        });
      }),
      filter((x: any) => x?.type === HttpEventType.Response),
      map((x: any) => {
        return x.body;
      })
    );
  }

  post(token: string, relation: string, correlationId: string, body: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${token}`,
        'x-itau-correlationID': correlationId,
        'x-itau-apikey': environment.apiKey
      })
    };

    this.charonService.config({
      entryPoint: environment.charonEntrypoint,
      httpOptions: {
        headers: httpOptions.headers
      }
    });

    return this.charonService.initialize(httpOptions).pipe(
      filter((x: any) => x?.type === HttpEventType.Response),
      switchMap(() => {
        return this.charonService.post(relation, body, {
          headers: httpOptions.headers,
          observe: 'body',
          responseType: 'text'
        });
      }),
      filter((x) => x.ok),
      map((x) => {
        return x.body ? JSON.parse(x.body) : {};
      })
    );
  }
}
